import { render } from "./ProfileViewDialog.vue?vue&type=template&id=f0f5de90"
import script from "./profile-view-dialog-component.ts?vue&type=script&lang=js&external"
export * from "./profile-view-dialog-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__